
import { Product } from '../types/product';

/**
 * Processes products for an offer page, ensuring consistent data structure
 * @param products Raw product data from the database
 * @returns Processed products with normalized fields
 */
export function processOfferProducts(products: any[]): Product[] {
  return products.map(product => {
    // Normalize product fields to match the Product interface requirements
    return {
      ...product,
      title: product.name || product.title || 'Unnamed Product',
      amount: product.price_cents || 0,
      // Required fields from Product interface that might be missing
      description: product.description || '',
      price_cents: product.price_cents || 0,
      status: product.status || 'active',
      billing_period: product.billing_period || 'one_time',
      user_id: product.user_id,
      created_at: product.created_at,
      // Preserve the connectedAccountId if it exists
      connectedAccountId: product.connectedAccountId || product.seller?.stripeAccountId
    };
  });
}

/**
 * Generates a demo offer product for testing
 */
export function generateDemoOfferProduct(): Product {
  return {
    id: `prod_demo_${Math.random().toString(36).substring(2, 7)}`,
    title: 'Demo Product',
    name: 'Demo Product',
    description: 'This is a demo product for testing',
    amount: 1000,
    price_cents: 1000,
    status: 'active',
    created_at: new Date().toISOString(),
    billing_period: 'one_time',
    user_id: 'demo_user_id',
    is_test:import.meta.env.VITE_APP_ENV != "production",
  };
}
